<template>
  <!-- 在线咨询 -->
  <div class="eprights-cont">
    <div class="left-tabs">
      <a class="active" @click="gotoOnline">在线咨询</a>
      <a @click="gotoHistory">历史咨询</a>
    </div>
    <div class="right-laws">
      <div class="g-main">
        <!-- <h3 class="titleh3">申请须知</h3>
        <div class="applay-info">
          <ul class="m-applay">
            <li>1、请认真填写表格（带<span class="red">*</span>为必填）。</li>
            <li>
              2、请留下您的真实姓名、联系电话、信箱地址、以便更好地与您联系！
            </li>
            <li>
              3、在提交完成后您将得到办理编号和查询码，请妥善保存，以备查用。
            </li>
          </ul>
        </div> -->
        <h3 class="titleh3">填写申请信息</h3>
        <div class="applay-info">
          <a-form-model
            ref="consultForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-form-model-item label="标题" prop="title">
              <a-input v-model="form.title" placeholder="请填写" />
            </a-form-model-item>
            <a-form-model-item label="姓名" prop="creator_name">
              <a-input v-model="form.creator_name" placeholder="请填写" />
            </a-form-model-item>
            <a-form-model-item label="手机号码" prop="creator_mobile_number">
              <a-input
                v-model="form.creator_mobile_number"
                placeholder="请填写"
              />
            </a-form-model-item>
            <a-form-model-item label="身份证号" prop="creator_certificate_number">
              <a-input v-model="form.creator_certificate_number"/>
            </a-form-model-item>
            <a-form-model-item label="邮箱" prop="creator_email">
              <a-input v-model="form.creator_email" placeholder="请填写" />
            </a-form-model-item>
            <a-form-model-item
              label="工作单位"
              prop="creator_work_organization"
            >
              <a-input
                v-model="form.creator_work_organization"
                placeholder="请填写"
              />
            </a-form-model-item>
            <a-form-model-item label="事件发生地" prop="matter_site">
              <a-input v-model="form.matter_site" placeholder="请填写" />
            </a-form-model-item>
            <a-form-model-item label="咨询分类" prop="consult_type">
              <a-select
                v-model="form.consult_type"
                placeholder="请选择"
                style="width: 100%"
              >
                <a-select-option
                  v-for="(value, key, index) in consultTypeOption"
                  :key="'consult_type_' + key"
                  :value="key"
                  >{{ value }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="咨询内容" prop="content">
              <a-textarea
                v-model="form.content"
                placeholder="请填写"
                :auto-size="{ minRows: 2, maxRows: 5 }"
              />
            </a-form-model-item>
            <a-form-model-item label="是否公开" prop="public_indicant">
              <a-select
                v-model="form.public_indicant"
                placeholder="请选择"
                style="width: 100%"
              >
                <a-select-option
                  v-for="(value, key, index) in isOnlineSignOption"
                  :key="'isOpen_' + key"
                  :value="key"
                  >{{ value }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="提交对象" prop="accept_unit_id">
              <a-cascader
                :options="unitOptions"
                v-model="form.accept_unit_id"
                placeholder="请选择"
                @change="changeUnit"
                changeOnSelect
              ></a-cascader>
            </a-form-model-item>

            <a-form-model-item label="相关材料" prop="att_url">
              <a-upload
                ref="att"
                v-decorator="[
                  'upload',
                  { valuePropName: 'fileList', getValueFromEvent: normFile },
                ]"
                name="Attachment"
                :data="{ path: 'file' }"
                :action="BASEURL+'api/annex/uploads'"
                v-model="form.att_url"
                @change="handleUpload"
                :key="'uploadkey'+uploadkey"
              >
                <a-button>
                  <a-icon type="upload" />
                  选择上传附件
                </a-button>
              </a-upload>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
              <a-button type="primary" @click="onSubmit"> 提交 </a-button>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

var _czc = _czc || [];
(function () {
  var um = document.createElement("script");
  um.src = "https://v1.cnzz.com/z.js?id=1281457514&async=1";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(um, s);
})();

import {saveConsult} from '@/api/consult';
import {getDept} from '@/api/index.js';
import {getCurrentUser} from '@/api/login';

export default {
  name: 'OnlineCult',
  data() {
    const validateNameCheck = (rule, value, callback) => {
      let num =0;
      num=value.length;
      // for (var i = 0; i < value.length; i++) {
      //   if (/[\u4e00-\u9fa5]/.test(value[i])) {
      //     num += 2
      //   } else {
      //     num++
      //   }
      // }
      // console.log(num)
      if (num > 20) {
        callback(new Error('标题最多20个文字！'))
      } else {
        callback()
      }
    };
    const validatePhoneCheck = (rule, value, callback) => {
      // 定义正则表达式
      const phoneRegex = /^(?:1(?:3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-9]))\d{8}$/;
      let num =0;
      num=value.length;
      // for (var i = 0; i < value.length; i++) {
      //   if (/[\u4e00-\u9fa5]/.test(value[i])) {
      //     num += 2
      //   } else {
      //     num++
      //   }
      // }
      // console.log(num)
      if (!phoneRegex.test(value)) {
        callback(new Error('手机号码校验不正确！'))
      } else {
        callback()
      }
    };
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      form: {
        accept_unit_id: [], //提交对象
        title: "",
        consult_type: "",
        matter_site: "",
        content: "",
        public_indicant: "",
        creator_name: "",
        creator_mobile_number: "",
        creator_work_organization: "",
        creator_certificate_number: "",
      },
      rules: {
        title: [{required: true, message: '请输入标题', trigger: 'blur'}, { validator: validateNameCheck, trigger: 'blur' }
        ],
        consult_type: [
          {required: true, message: '请选择咨询分类', trigger: 'change'},
        ],
        matter_site: [
          {required: true, message: '请输入事件发生地', trigger: 'blur'},
        ],
        content: [
          {required: true, message: '请输入咨询内容', trigger: 'blur'},
        ],
        public_indicant: [
          { required: true, message: '请选择是否公开', trigger: 'change' },
        ],
        accept_unit_id: [
          {required: true, message: '请选择提交对象', trigger: 'change'},
        ],
        creator_name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        // creator_member_indicant: [{required: true, message: '请选择是否会员', trigger: 'change'},],
        creator_mobile_number: [
          {required: true, message: '请输入手机号码', trigger: 'blur'}, {validator: validatePhoneCheck, trigger: 'blur'}
        ],
        creator_certificate_number: [
          {required: true, message: '请输入证件号码', trigger: 'blur'},
        ],
        creator_work_organization: [
          {required: true, message: '请输入工作单位', trigger: 'blur'},
        ],
      },
      isOnlineSignOption: [],
      consultTypeOption: [],
      unit_id: '',
      unitOptions: [],
      uploadkey:1,
    };
  },
  created() {
    this.getDept();
  },
  mounted() {
    this.initCategory();
    let webId = JSON.parse(localStorage.getItem('webid'))
    if(webId == null){
      this.form.accept_unit_id = []
    }else if(webId == "1"){
      this.form.accept_unit_id = ["32"]
    }else{
      this.form.accept_unit_id = ["32",`${webId}`]
    }
    this.$forceUpdate()
  },
  methods: {
    async initCategory() {
      this.isOnlineSignOption = this.$store.state.category.IsOnlineSign;
      this.consultTypeOption = this.$store.state.category.ConsultType;
      getCurrentUser().then((res) => {
        console.log(res)
        this.form.creator_name = res.name;
        if (res.mobile) {
          this.form.creator_mobile_number = res.mobile;
        }
        if (res.cardid) {
          this.form.creator_certificate_number = res.cardid;
        }
      });
    },
    getDept() {
      getDept().then((res) => {
        // console.log(res);
        console.log(res)
        this.unitOptions = res;
      });
    },
    onSubmit() {
      this.$refs.consultForm.validate(async (valid) => {
        if (valid) {
          // 提交时只提交一个地市
          this.form.accept_unit_id = this.form.accept_unit_id[this.form.accept_unit_id.length-1]
          await saveConsult(this.form);
          this.$message.success('提交成功');
          this.resetForm();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.consultForm.resetFields();
      this.form.accept_unit_id = [];
      this.uploadkey++;
    },
    selectUnitClick(v) {
      console.log(v);
    },
    gotoOnline() {
      this.$router.push({ name: 'OnlineCult' });
    },
    gotoHistory: function () {
      this.$router.push({ name: 'HistoryCult' });
    },
    changeUnit(ids) {
      console.log(ids)
      // this.form.accept_unit_id = ids[ids.length - 1];
      // console.log(this.form.accept_unit_id)
    },
    handleUpload(info) {
      if (info.file.status === 'done') {
        let img_url =
          info.file.response.data.items[0].file_path +
          '/' +
          info.file.response.data.items[0].file_name;
        this.form.att_url = img_url;
      }
    },
    normFile(e) {
      console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
  },
};
</script>
<style scoped>
.eprights-cont {
  display: flex;
}

.left-tabs {
  width: 260px;
  text-align: center;
  padding-top: 20px;
}

.left-tabs a {
  display: inline-block;
  width: 220px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-size: 18px;
  color: #666;
  background: #fafbfc;
  border: 1px solid #d9dfe8;
  box-sizing: border-box;
}

.left-tabs a + a {
  margin-top: 10px;
}

.left-tabs a.active {
  color: #0079df;
  background: #f3f9ff;
  border: 1px solid #78c1ff;
}

.right-laws {
  flex: 1;
  padding-top: 10px;
}

.applay-info {
  border: 1px solid #d9dfe8;
}

.m-applay {
  margin-bottom: 0;
  padding: 15px 20px;
}

.m-applay li {
  list-style: none;
  line-height: 35px;
}

span.red {
  color: #f00;
}

.applay-info .ant-form {
  padding-top: 20px;
}
</style>
